var fails = require('./fails');

module.exports = fails(function () {
  // babel-minify transpiles RegExp('.', 'g') -> /./g and it causes SyntaxError
  var re = RegExp('(?<a>b)', (typeof '').charAt(5));
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/regexp-unsupported-ncg.js